<script>
import { useRoute } from "vue-router";
import router from "./router/index.js";

export default {
  name: 'App',

  data() {
    return {
      windowHeight: window.innerHeight,
      route: useRoute()
    };
  },

  mounted() {
    this.updateWindowHeight()

    const element = this.$refs.app;


    // Создаем новый ResizeObserver
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;

        this.updateWindowHeight(height)
      }
    });

    // Наблюдаем за изменениями размеров элемента
    this.resizeObserver.observe(element);
  },

  methods: {
    updateHeight(){
      this.updateWindowHeight()
    }
  },
  created() {
    window.addEventListener('resize', this.updateWindowHeight);
  },
  updated() {
    this.updateWindowHeight()
  },

  beforeUnmount() {
    // Очищаем наблюдателя перед размонтированием компонента
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowHeight);
  },

  watch: {
    $route(newVal, oldVal) {
      this.updateWindowHeight()
    },
  }
}
</script>

<template>
  <div id="app_content" ref="app">
    <router-view></router-view>
  </div>
</template>

<style scoped>

</style>
